import {EventEmitter, Injectable} from '@angular/core';
import {IonModal, MenuController, ToastController} from '@ionic/angular';
import {AlertController} from '@ionic/angular';
import {HelperService} from './helper.service';
import {LoadingController} from '@ionic/angular';
import {File} from 'app/entities/file.entity';
import {ModalOptions} from '@ionic/core';
import {SwitchItem} from '../entities/switch.entity';
import {SelectModalComponent} from '../components/shared/selectModal/item';
import {SearchModelService} from '../core/search.interface';
import {AppModalService} from './appModal.service';
import {AngularFireAnalytics} from '@angular/fire/compat/analytics';
import {Title} from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class AppService {

  appReady = false;
  toastController: ToastController;
  menu: MenuController;
  loadingController: LoadingController;
  appModalService: AppModalService;
  analytics: AngularFireAnalytics;
  titleService: Title;

  loading: any;
  isLoading = false;
  loadingCounter = 0;
  isShowToolbar = false;
  offline = false;

  pushData: any = null;

  private alertController: AlertController;
  private blockBack = false;
  private alertElement: HTMLIonAlertElement;

  constructor(
    menu: MenuController,
    alertController: AlertController,
    toastController: ToastController,
    loadingController: LoadingController,
    appModalService: AppModalService,
    titleService: Title,
    analytics: AngularFireAnalytics
  ) {

    this.menu = menu;
    this.alertController = alertController;
    this.toastController = toastController;
    this.loadingController = loadingController;
    this.appModalService = appModalService;
    this.analytics = analytics;
    this.titleService = titleService;

  }

  /**
   * WARNING it is important to call it with await flag, otherwise it can be closed before opens
   */
  async showLoading() {
    this.loadingCounter++;

    // if (!this.isLoading && !this.startPage) {
    if (!this.isLoading) {

      this.isLoading = true;

      this.loading = await this.loadingController.create({
        // message: '<ion-img class="loading-spinner" src="/assets/logo-img.svg" alt="loading..."></ion-img>',
        message: '<div class="loading-spinner-container">' +
          '<ion-img class="loading-spinner" src="/assets/logo-img.svg" alt="loading...">' +
          '</ion-img>' +
          '</div>',
        cssClass: 'loading-container',
        spinner: null,
        translucent: true,
        showBackdrop: false,
        // animated: false,   // TODO анимации появления/скрытия лоадера возможно стоит кастомизировать
      });

      await this.loading.present();
    }
  }

  async hideLoading(all = false) {
    this.loadingCounter--;

    if (all) {
      this.loadingCounter = 0;
    }

    if (this.loadingCounter <= 0) {

      if (this.loading) {
        this.loading.dismiss();
        this.loading = null;
      }

      this.loadingCounter = 0;

      this.isLoading = false;
      return await this.loadingController.dismiss(null, 'cancel');
    }

    return null;
  }

  async showAlert(title: string, desc: string, error: boolean, callback: () => void = null) {
    this.alertElement = await this.alertController.create({
      header: title,
      message: desc,
      buttons: ['Ok']
    });

    await this.alertElement.present();

    await this.alertElement.onDidDismiss().then((res) => {

      if (callback) {
        callback();
      }

      this.alertElement = null;
    });

  }

  async showTestAlert(text: string, callback: (res: string) => void = null) {
    this.alertElement = await this.alertController.create({
      buttons: ['Ok'],
      mode: 'ios',
      inputs: [
        {
          type: 'textarea',
          value: text
        },
      ],
    });

    await this.alertElement.present();

    await this.alertElement.onDidDismiss().then((res) => {

      if (callback) {
        callback(res.data.values[0]);
      }

      this.alertElement = null;
    });

  }

  async showToast(
    text: string,
    type: 'default' | 'primary' | 'success' | 'danger' = 'default',
    buttonText: string = null,
    buttonCallback: () => void = null,
    duration = 2000   // to set to infinite: null or 0
  ) {
    const buttons = [
      {
        icon: 'assets/icons/cancel-cross-button.svg',
        role: 'cancel'
      }
    ];

    // Две разные кнопки внутри тоста затемить нельзя (из-за shadow dom). Поэтому cancel-button темится
    // как обычно (через айкон), а вторая, info-button - сама КНОПКА делается невидимой. А в
    // том месте где визуально кнопка должна быть - выводится надпись с помощью поля 'text'. А в момент когда тост завершает
    // появление, кнопке info подменяется стиль чтобы она оставаясь невидимой вставала своей активной областью на место
    // надписи. Т.о. решается проблема дерганой анимации появления доп. кнопки.
    if (buttonText) {
      const clickButton: any = {
        cssClass: 'toast-info-button',
        role: 'info'
      };

      if (buttonCallback) {
        clickButton.handler = buttonCallback;
      }

      buttons.push(clickButton);
    }

    const toast = await this.toastController.create({
      header: text,
      message: buttonText ? buttonText : undefined,
      duration,
      cssClass: `toast-type-${type} app-toast-wrapper`,
      translucent: false,
      position: 'top',
      mode: 'ios',
      buttons,
    });

    await toast.present().then(() => {
      // damn the day when someone decide to add shadow css, and stupid
      // ionic decided to support this shitty idea, because of what we now force to write this shit code! OMG!
      const toasts = document.getElementsByClassName('app-toast-wrapper');
      const shadow = toasts[0].shadowRoot;
      const childNodes = Array.from(shadow.childNodes);
      childNodes.forEach((childNode: any) => {
        const infoButton = childNode.getElementsByClassName('toast-info-button');
        if (infoButton) {
          infoButton[0]?.setAttribute('part', 'button-info');
        }

        const cancelButton = childNode.getElementsByClassName('toast-close-icon');
        if (cancelButton) {
          cancelButton[0]?.setAttribute('part', 'button-cancel');
        }

        const groupButton = childNode.getElementsByClassName('toast-button-group');
        if (groupButton) {
          groupButton[0]?.setAttribute('part', 'button-group');
        }
      });
    });

    await toast.onDidDismiss().then(() => {
      // console.log('toast onDidDismiss');
    });
  }

  showToolbar() {
    this.isShowToolbar = true;
  }

  hideToolbar() {
    this.isShowToolbar = false;
  }

  getLocalStorage(key: string, defaultValue = null) {

    // if (key === 'token') {
    //   return 'aLYCiDUI64z4cD7bBG8bA1UsTzWsYS9j';
    // }

    const v = localStorage.getItem(key);
    return v ? v : defaultValue;
  }

  setLocalStorage(key: string, value: string | null) {

    if (value === null) {
      return localStorage.removeItem(key);
    } else {
      return localStorage.setItem(key, value);
    }

  }

  async back() {
    if (this.isLoading) {
      return false;
    }

    if (this.blockBack) {
      return false;
    }

    // // close action sheet
    // try {
    //   const element = await this.actionSheetCtrl.getTop();
    //   if (element) {
    //     element.dismiss();
    //     return;
    //   }
    // } catch (error) {
    // }

    // close popover
    await this.closeToast();

    // close modal
    await this.appModalService.closeTopModal();

    // // close side menu
    // try {
    //   const element = await this.menu.getOpen();
    //   if (element !== null) {
    //     this.menu.close();
    //     return;
    //   }
    // } catch (error) {
    // }
  }

  async closeToast() {
    try {
      const element = await this.toastController.getTop();
      if (element) {
        element.dismiss();
        return;
      }
    } catch (error) {
    }
  }

  setOffline() {
    this.offline = true;
  }

  setOnline() {
    this.offline = false;
  }

  refresh() {
    window.location.reload();
  }

  setGAUserId(userId) {
    this.analytics.setUserId(userId);
  }

  setTitle(title: string) {
    this.titleService.setTitle(title);
  }

  async menuToggle() {
    await this.menu.toggle();
  }

  menuOpen() {
    this.menu.open();
  }

  async menuClose() {
    await this.menu.close();
  }
}
